<div class="topbar row px-4 mt-3">
  <div class="col d-flex align-items-center">
    <h3 class="font-weight-bold nav-font16 nav-secondary mb-0">
      <i class="fak fa-notes grey4 mr-2 font-weight-normal"></i>Notes {{notes?.length > 0 ? '(' + notes?.length  + ')' : ''}}
    </h3>
  </div>
  <div class="col d-flex align-items-center justify-content-end pr-2">
    <div class="grid-actions position-relative">
      <div class="d-flex align-items-center justify-content-center" [class.invisible]="isVendorOrClient">
        @if (filtersApplied?.length > 0) {
          <div class="circle filter-active">{{filtersApplied?.length}}</div>
        }
        <or-filter [values]="filterValues" position="left" positionDistance="140" (filter)="applyFilter($event)"></or-filter>
      </div>
      <div class="sep position-relative" [class.invisible]="isVendorOrClient"></div>
      <div class="d-flex align-items-center justify-content-center">
        <button type="button" class="far fa-close nav-font18 cursor-pointer grey4 bg-transparent border-0 p-0" aria-label="Close" (click)="close()"></button>
      </div>
    </div>
  </div>
</div>

@if (!bidNumber) {
  <div class="mt-1 notes w-100" [class.border-bottom]="!addNoteModeOn && getNotesConfirmEditsCount() > 0">

    <!-- Add Note -->
    @if (addNoteModeOn) {
      <div class="add-note-card px-3 mb-1 border-bottom" [class.mt-3]="clientId || vendorId">
        @if (!isVendorOrClient) {
          <div class="pt-3 pb-2">
            <span class="nav-font12 grey4 d-block mb-2">Share With</span>
            <ng-template *ngTemplateOutlet="tplNoteTypes; context: { $implicit: newNote }"></ng-template>
            @if (newNote?.userType === 'Client' && resolvedClientName) {
              <span class="client-badge d-inline-block nav-font12 my-2">{{ resolvedClientName }}</span>
            }
          </div>
        }
        @if (newNote?.userType == 'Vendor' && !isVendorOrClient && !vendorId) {
          <div class="pb-2">
            <or-type-ahead
              [(ngModel)]="newNote.vendors"
              name="vendors"
              [labelField]="'name'"
              [valueField]="'id'"
              [multi]="true"
              [dropdownMode]="true"
              containerBody=true
              [dataCallback]="getVendors"
              class="vendor-typeahead nav-font14"
              (valueChange)="updateNoteVendors(newNote, $event)"
              [placeholder]="allVendorsAdded ? 'All project vendors added' : (newNote?.vendors?.length > 0 ? 'Type to add more...' : 'Type to add vendors...')"
              [disabled]="allVendorsAdded"
              [selectedValues]="newNote.vendors">
            </or-type-ahead>
          </div>
        }
        <div class="pb-2">
          <div class="note-input-box">
            <div class="ckeditor pl-3 pr-0 position-relative">
              <button type="button" class="expand-note-btn expand-note-corner bg-transparent border-0 p-0 grey4 position-absolute" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openComposeModal()">
                <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
              </button>
              <or-wysiwyg (messageEvent)="receiveMessage($event)" [config]="editorConfig" [data]="newNote?.message == null ? '' : newNote?.message"></or-wysiwyg>
            </div>
            @if (newNote?.userType === 'Team') {
              <div class="share-info-banner d-flex align-items-center px-2 py-2 nav-font12">
                <i class="fak fa-bullhorn mr-2"></i>
                This note will be shared with <strong class="ml-1 nav-black1">OpinionRoute Staff.</strong>
              </div>
            } @else if (newNote?.userType === 'Client') {
              @if (resolvedClientName) {
                <div class="share-info-banner d-flex align-items-center px-2 py-2 nav-font12">
                  <i class="fak fa-bullhorn mr-2"></i>
                  This note will be shared with <strong class="ml-1 nav-black1">{{ resolvedClientName }}.</strong>
                </div>
              } @else {
                <div class="share-error-banner d-flex align-items-center px-2 py-2 nav-font12">
                  <i class="fas fa-exclamation-circle mr-2"></i>
                  There is no client added to this Project.
                </div>
              }
            } @else if (newNote?.userType === 'Vendor') {
              @if (vendorId || newNote?.vendors?.length > 0) {
                <div class="share-info-banner d-flex align-items-start px-2 py-2 nav-font12">
                  <i class="fak fa-bullhorn mr-2 flex-shrink-0 mt-1"></i>
                  <span>This note will be shared with <strong>{{ getVendorBannerName() }}.</strong></span>
                </div>
              } @else {
                <div class="share-info-banner share-info-neutral d-flex align-items-center px-2 py-2 nav-font12">
                  <i class="fak fa-bullhorn mr-2 flex-shrink-0"></i>
                  <span>Select vendors above to see who this note will be shared with.</span>
                </div>
              }
            }
          </div>
        </div>
        <div class="pb-2">
          <ng-template *ngTemplateOutlet="tplAttachmentEditor; context: { $implicit: newNoteDraft }"></ng-template>
        </div>
        <div class="bottom-actions pl-1 pt-1 pb-2">
          @if (!isVendorOrClient) {
            @if (newNote.sendAsEmail) {
              @if (newNote.userType === 'Client' && !project?.clientContactId) {
                <div class="share-error-banner d-flex align-items-center px-2 py-2 nav-font12">
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No point of contact set for this client.
                  <span class="nav-accent-blue cursor-pointer font-weight-bold ml-auto pr-1" (click)="openContactPicker('client')">+ Set Contact</span>
                </div>
              } @else if (newNote.userType === 'Vendor' && anyVendorHasNoContacts()) {
                <div class="share-error-banner d-flex align-items-center px-2 py-2 nav-font12">
                  <i class="fas fa-exclamation-triangle mr-2 flex-shrink-0"></i>
                  <span>No contact set for <strong>{{ getVendorNames(vendorsMissingContacts) }}</strong>.</span>
                  <span class="nav-accent-blue cursor-pointer font-weight-bold ml-auto pl-2 pr-1 flex-shrink-0" (click)="openContactPicker('vendor')">+ Set Contact</span>
                </div>
              } @else if (newNote.userType === 'Team' && hasNoTeamMembers()) {
                <div class="no-contact-warning d-flex align-items-center mt-1 nav-font12">
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  No team members found for this project — email will not be sent.
                </div>
              }
            }
            @if (showContactPicker) {
            <div class="contact-picker-panel mt-2 mb-3">
              @if (!showAddContactForm) {
                <div class="nav-font13 font-weight-bold nav-secondary mb-2">Select or add a contact for {{ pickerTitle }}</div>
                @if (contactPickerMode === 'vendor' && vendorsMissingContacts.length > 1) {
                  <select class="form-control nav-font12 mb-2" [class.is-placeholder]="!pickerVendorId" [(ngModel)]="pickerVendorId" (ngModelChange)="onPickerVendorChange()">
                    <option [ngValue]="null" disabled hidden>Select a vendor</option>
                    @for (v of vendorsMissingContacts; track v.id) {
                      <option [ngValue]="v.id">{{ v.name }}</option>
                    }
                  </select>
                }
                @if (contactPickerMode === 'client' || pickerVendorId) {
                  <input type="text" class="form-control nav-font12 picker-search mb-2" placeholder="Search contacts..." [(ngModel)]="contactPickerSearch">
                  <div class="picker-list mb-2">
                    @for (contact of filteredPickerContacts; track contact) {
                      <div class="picker-contact-item d-flex align-items-center p-2 cursor-pointer"
                           [class.selected]="selectedPickerContact?.id === contact.id"
                           (click)="selectedPickerContact = contact">
                        <or-profile-image [name]="contact.name" size="small" showInitials="true" class="mr-2 flex-shrink-0"></or-profile-image>
                        <div class="flex-grow-1">
                          <div class="picker-contact-name nav-font12 font-weight-bold">{{ contact.name }}</div>
                          <div class="nav-font12 grey4">{{ contact.email }}</div>
                        </div>
                      </div>
                    }
                    @if (filteredPickerContacts.length === 0) {
                      <div class="grey4 nav-font12 px-2 py-2">No contacts found.</div>
                    }
                  </div>
                }
                <div class="nav-accent-blue cursor-pointer nav-font12 font-weight-bold mb-2" (click)="initAddContactForm()">+ Add new contact</div>
                <div class="d-flex justify-content-end picker-actions">
                  <button type="button" class="btn btn-sm nav-btn-primary shadow-none mr-2" (click)="cancelContactPicker()">Cancel</button>
                  <button type="button" class="btn btn-sm nav-btn-accent shadow-none" [disabled]="!selectedPickerContact || contactPickerSaving" (click)="confirmContactSelection()">Select Contact</button>
                </div>
              } @else {
                <div class="nav-font13 font-weight-bold nav-secondary mb-2">Add new contact</div>
                @if (contactPickerMode === 'vendor') {
                  <select class="form-control nav-font12 mb-2" [class.is-placeholder]="!newPickerContact.vendorId" [(ngModel)]="newPickerContact.vendorId">
                    <option [ngValue]="null" disabled hidden>Select a vendor</option>
                    @for (v of vendorsMissingContacts; track v.id) {
                      <option [ngValue]="v.id">{{ v.name }}</option>
                    }
                  </select>
                }
                <div class="d-flex mb-2" style="gap: 8px">
                  <input type="text" class="form-control nav-font12" placeholder="First name *" [(ngModel)]="newPickerContact.firstName">
                  <input type="text" class="form-control nav-font12" placeholder="Last name *" [(ngModel)]="newPickerContact.lastName">
                </div>
                <input type="email" class="form-control nav-font12 mb-2" placeholder="Email *" [(ngModel)]="newPickerContact.email">
                <div class="d-flex justify-content-end picker-actions">
                  <button type="button" class="btn btn-sm nav-btn-primary shadow-none mr-2" (click)="showAddContactForm = false">Back</button>
                  <button type="button" class="btn btn-sm nav-btn-accent shadow-none" [disabled]="contactPickerSaving" (click)="saveNewPickerContact()">Save Contact</button>
                </div>
              }
            </div>
            }
          }
          <div class="d-flex align-items-center justify-content-between">
            <label class="d-flex align-items-center mb-0 cursor-pointer nav-font14 grey4">
              <input type="checkbox" [(ngModel)]="newNote.sendAsEmail" class="mr-2">
              Send as an email
            </label>
            <div>
              <button type="button" (click)="cancel()" class="btn btn-sm nav-btn-primary mx-2 shadow-none font-weight-bold py-1">Cancel</button>
              <button type="button" (click)="addNote()" class="btn btn-sm nav-btn-accent shadow-none py-1">Submit</button>
            </div>
          </div>
        </div>
      </div>
    } @else if (getNotesConfirmEditsCount() === 0) {
      <div class="add-note d-flex align-items-center" [class.border-bottom]="notes?.length > 0" [class.pb-1]="notes?.length > 0">
        <button type="button" class="btn nav-btn-accent shadow-none nav-font14 px-3 py-1" (click)="addNoteModeOn = true">
          <span class="font-weight-bold">+</span> Add Note
        </button>
      </div>
    }


    @if (loading) {
      <div class="d-flex align-items-center justify-content-center w-100 my-3 position-absolute">
        <span class="loading"></span>
      </div>
    }
    @else {
      @if (notes?.length > 0) {
        <ul class="nav pt-3 w-100 h-100 scrollbar overflow-y {{newNote?.userType}}" [class.add-mode-on]="addNoteModeOn || isAnyEditActive()">
          @for (note of notes; track note; let noteIdx = $index) {
            <!-- Note view -->
              <li class="w-100 px-3" [class.has-open-replies]="note.showReplies && note.replies?.length > 0" [class.reply-edit-active]="hasActiveReplyEdit(note)">
                <div class="note-card">
                <div class="note-grid">
                  <div class="profile-image">
                    <or-profile-image [name]="note.name" [url]="note.img" size="medium" showInitials="true"></or-profile-image>
                  </div>
                  <div class="mb-1">
                    <div class="info-grid">
                      <div class="d-flex align-items-center">
                        <span class="d-block font-weight-bold nav-black2 nav-font14 mb-0 text-truncate note-author" [tooltip]="note.name" container="body" placement="bottom">{{ note.name }}</span>
                        @if(!isVendorOrClient){<span class="badge badge-pill nav-font12 ml-2 font-weight-normal" [ngClass]="{'badge-note-team': note.userType === 'Team', 'badge-note-client': note.userType === 'Client', 'badge-note-vendor': note.userType === 'Vendor'}">{{ note.userType }}</span>}
                        @if(note.partnerName?.length > 0){<span class="badge badge-pill badge-vendor-label nav-font11 ml-1 font-weight-normal flex-shrink-0" container="body" [tooltip]="note.partnerName" placement="bottom">{{ note.partnerName.length > 6 ? (note.partnerName | slice:0:6) + '...' : note.partnerName }}</span>}
                      </div>
                      <div class="d-flex justify-content-end align-items-center note-actions-col">
                        <span class="grey4 nav-font10 text-nowrap flex-shrink-0 mr-2" container="body" [tooltip]="(note.cDate | date:'MMM d, y HH:mm')">{{ note.cDate | timeAgo: 'compact' }}</span>
                        @if (note.isEdited) {<span class="grey4 nav-font10 text-nowrap flex-shrink-0 mr-2">Edited</span>}
                        <button type="button" class="expand-note-btn bg-transparent border-0 p-0 grey4 expand-note-reveal d-inline-flex align-items-center mr-2" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openNoteView(note)">
                          <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
                        </button>
                        <div class="text-right" dropdown #ddActions="bs-dropdown" container="body" placement="bottom right">
                          @if (auth.getUser().id === note.userId) {
                            @if (!notesConfirmEdits[note.id]?.editModeOn && !notesConfirmEdits[note.id]?.addReplyModeOn && !addNoteModeOn) {
                              <button type="button" class="fak fa-ellipsis-vertical fa-lg cursor-pointer nav-black2 bg-transparent border-0 p-0" dropdownToggle aria-label="Note options" aria-haspopup="menu" [attr.aria-expanded]="ddActions.isOpen"></button>
                            }
                          }
                          <ul class="note-actions dropdown-menu dropdown-menu-right position-relative grey4 cursor-pointer p-1 nav-font14" (mouseleave)="ddActions.hide()" *dropdownMenu role="menu" aria-labelledby="button-triggers-manual">
                            <button type="button" class="dropdown-item px-3" role="menuitem" (click)="editNote(note); ddActions.hide()">Edit</button>
                            <hr class="mx-2 my-0">
                            <button type="button" class="dropdown-item px-3" role="menuitem" (click)="showDelete(note); ddActions.hide()">Delete</button>
                          </ul>
                        </div>
                      </div>
                    </div>
                    @if (project.id !== note.projectId) {
                      <div class="info-grid">
                        <div class="d-flex align-items-center">
                          <a class="cursor-pointer nav-accent-blue font-weight-bold nav-font12 mr-1 note-link" [routerLink]="['/projects', note.projectId]">
                            {{ note.projectCode }} - {{ note.projectName }}
                          </a>
                        </div>
                      </div>
                    }

                    @if (note.usersDisplay?.length > 0) {
                      <div class="tagged-users row mt-2 mb-3">
                        <div class="col">
                          <div class="d-flex align-items-center gap-2">
                            @for (item of getDisplayItems(note); track $index) {
                              <span class="badge bg-secondary grey4 px-2 py-1 nav-font12">{{ item }}</span>
                            }
                            @if (showPlusButton(note)) {
                              <span class="badge bg-secondary grey4 px-2 py-1 nav-font12 font-weight-bold nav-accent-blue"
                                    container="body"
                                    (mouseenter)="currentNoteTooltip = note"
                                    placement="bottom"
                                    [tooltip]="tooltipTemplate">
                                +{{ getRemainingCount(note) }}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    }

                    <div class="row mt-2">
                      <div class="col">
                        @if (!notesConfirmEdits[note.id]?.editModeOn) {
                          <div class="nav-font14 grey4 word-wrap-break">
                            <div class="note-message pr-2 mb-2" [innerHTML]="parseNote(note.message, note.id)" (click)="onNoteMessageClick($event, note)"></div>
                          </div>
                        }
                        @if (note.attachments?.length > 0) {
                          <ng-template *ngTemplateOutlet="tplNoteAttachments; context: { $implicit: note }"></ng-template>
                        }
                      </div>
                    </div>

                    <!-- Reply / Emoji -->
                    @if (!notesConfirmEdits[note.id]?.addReplyModeOn) {
                      <div class="d-flex align-items-center flex-wrap mt-2" [class.d-none]="notesConfirmEdits[note.id]?.editModeOn">
                        <!-- Left: emoji reactions + emoji picker + Reply -->
                        <div class="d-flex align-items-center">
                          <div class="reactions-group d-flex align-items-center">
                            @for (reaction of note.reactions; track reaction; let reactionIdx = $index) {
                              <button type="button" [tooltip]="reactionTooltip" placement="bottom" container="body" containerClass="reactionTooltip" class="likes cursor-pointer d-inline-block bg-transparent {{reaction.reactedByMe ? 'reactedByMe' : ''}}" [attr.aria-pressed]="!!reaction.reactedByMe" (click)="reactToNote(note, reaction.type);">
                                <ng-template #reactionTooltip>
                                  <table class="w-100">
                                    <tbody>
                                      @if (reaction.reactedByMe) {
                                        <tr>
                                          <td class="text-left pr-3">You</td>
                                          <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                        </tr>
                                      }
                                      @for (user of reaction.reactedBy; track name; let nameIdx = $index) {
                                        @if (nameIdx < 5) {
                                          <tr>
                                            <td class="text-left pr-3">{{user.name}}</td>
                                            <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                          </tr>
                                        }
                                        @if (nameIdx == 5) {
                                          <tr>
                                            <td class="text-left pr-3">and {{reaction.reactedBy.length - 5}} more...</td>
                                            <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                          </tr>
                                        }
                                      }
                                    <tbody>
                                  </table>
                                </ng-template>
                                <div class="d-flex align-items-center justify-content-center w-100 h-100">
                                  <app-emoji class="mb-1" [size]="'small'" [onHoverAction]="'background-change'" [name]="reaction.type"></app-emoji>
                                  <span class="reaction-count">{{reaction.reactedBy.length + (reaction.reactedByMe ? 1 : 0)}}</span>
                                </div>
                              </button>
                            }
                            <ng-template *ngTemplateOutlet="reactions; context: { $implicit: note }"></ng-template>
                          </div>
                          <button type="button" class="cursor-pointer nav-accent-blue font-weight-bold nav-font14 ml-2 note-link bg-transparent border-0 p-0" (click)="replyToNote(note)">Reply</button>
                        </div>
                        <!-- Right: reply count + toggle chevron -->
                        @if (note.replies?.length > 0) {
                          <button type="button" class="d-flex align-items-center ml-auto cursor-pointer grey4 nav-font14 reply-toggle bg-transparent border-0 p-0" [attr.aria-expanded]="!!note.showReplies" (click)="note.showReplies = !note.showReplies">
                            <i class="far fa-comment-alt mr-1" aria-hidden="true"></i>
                            <span class="mr-1">{{ note.replies.length }} {{ note.replies.length === 1 ? 'reply' : 'replies' }}</span>
                            <i class="far nav-font10" [ngClass]="{'fa-chevron-up': note.showReplies, 'fa-chevron-down': !note.showReplies}" aria-hidden="true"></i>
                          </button>
                        }
                      </div>
                    }
                  </div>

                </div>

                <!-- View Replies -->
                @if (!notesConfirmEdits[note.id]?.addReplyModeOn && note.showReplies && note.replies?.length > 0 && !notesConfirmEdits[note.id]?.editModeOn) {
                  <div class="replies w-100 mt-4">
                    <div class="items" *ngIf="note.showReplies">
                      <ng-template *ngTemplateOutlet="tplReplies; context: { $implicit: note }"></ng-template>
                    </div>
                  </div>
                }
                </div>
              </li>

            <!-- Add Reply -->
            @if (notesConfirmEdits[note.id]?.addReplyModeOn) {
              <li class="edit-note bg-white w-100 note-active" [ngClass]="(noteIdx+1) < notes.length ? 'border-bottom-0' : 'border-bottom pb-2'">
                <div class="text-right">
                  <div class="col ckeditor position-relative pr-0">
                    <button type="button" class="expand-note-btn expand-note-corner bg-transparent border-0 p-0 grey4 position-absolute" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openAddReplyModal(note)">
                      <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
                    </button>
                    <or-wysiwyg (messageEvent)="notesConfirmEdits[note.id].replyMessage = $event" [config]="editorReplyConfig"></or-wysiwyg>
                    <div class="save-note mr-1">
                      <button type="button" (click)="cancel(note)" class="btn btn-sm nav-btn-primary mx-2 shadow-none font-weight-bold py-1">Cancel</button>
                      <button type="button" (click)="saveReply(note)" class="btn btn-sm nav-btn-accent shadow-none py-1">Submit</button>
                    </div>
                  </div>
                </div>
              </li>
            }

            <!-- Edit Note -->
            @if (notesConfirmEdits[note.id]?.editModeOn) {
              <li class="bg-white w-100 note-active">
                <div class="edit-note-box w-100 border-0">
                  <div class="text-right">
                    <div class="col ckeditor position-relative pr-0">
                      <button type="button" class="expand-note-btn expand-note-corner bg-transparent border-0 p-0 grey4 position-absolute" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openNoteEdit(note)">
                        <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
                      </button>
                      <or-wysiwyg (messageEvent)="notesConfirmEdits[note.id].message = $event" [config]="editorConfig" [data]="notesConfirmEdits[note.id].message"></or-wysiwyg>
                      <div class="text-left pt-2 pr-3">
                        <ng-template *ngTemplateOutlet="tplAttachmentEditor; context: { $implicit: note.id }"></ng-template>
                      </div>
                      <!-- with attachments below the editor the toolbar row isn't the bottom, so the buttons get their own row -->
                      <div class="save-note save-note-row mr-1">
                        <button type="button" (click)="cancel(note)" class="btn btn-sm nav-btn-primary mx-2 shadow-none font-weight-bold py-1">Cancel</button>
                        <button type="button" (click)="updateNote(note)" class="btn btn-sm nav-btn-accent shadow-none py-1">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            }
          }
        </ul>
      }
    }
  </div>
}

@if (bidNumber && bidNumber != '') {
  <div class="mt-1 notes w-100">

    @if (loading) {
      <div class="d-flex align-items-center justify-content-center w-100 my-3 position-absolute">
        <span class="loading"></span>
      </div>
    }
    @else {
      <!-- Notes list -->
      <ul class="nav pt-3 w-100 h-100 scrollbar overflow-y " [class.add-mode-on]="addNoteModeOn">
        @for (note of notes; track note; let noteIdx = $index) {
          <li class="w-100 px-3" [class.has-open-replies]="note.showReplies && note.replies?.length > 0" [class.reply-edit-active]="hasActiveReplyEdit(note)">
            <div class="note-card">
            <div class="note-grid">
              <div class="profile-image">
                <or-profile-image [name]="note.name" [url]="note.img" size="medium" showInitials="true"></or-profile-image>
              </div>
              <div class="mb-1">
                <div class="info-grid">
                  <div class="d-flex align-items-center">
                    <span class="d-block font-weight-bold nav-black2 nav-font14 mb-0 text-truncate note-author" [tooltip]="note.name" container="body" placement="bottom">{{ note.name }}</span>
                    <span class="badge badge-pill nav-font12 mx-2 font-weight-normal" [ngClass]="{'badge-note-team': note.userType === 'Team', 'badge-note-client': note.userType === 'Client', 'badge-note-vendor': note.userType === 'Vendor'}">{{ note.userType }}</span>
                    @if(note.partnerName?.length > 0){<span class="badge badge-pill badge-vendor-label nav-font11 ml-1 font-weight-normal flex-shrink-0" container="body" [tooltip]="note.partnerName" placement="bottom">{{ note.partnerName.length > 6 ? (note.partnerName | slice:0:6) + '...' : note.partnerName }}</span>}
                    <span class="grey4 nav-font10 ml-auto pl-3 text-nowrap flex-shrink-0" container="body" placement="bottom" [tooltip]="(note.cDate | date:'MMM d, y HH:mm')">{{ note.cDate | timeAgo: 'compact' }}</span>
                    <button type="button" class="expand-note-btn bg-transparent border-0 p-0 grey4 expand-note-reveal d-inline-flex align-items-center ml-2" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openNoteView(note)">
                      <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                @if (project.id !== note.projectId) {
                  <div class="info-grid">
                    <div class="d-flex align-items-center">
                      <a class="cursor-pointer nav-accent-blue font-weight-bold nav-font12 mr-1 note-link" [routerLink]="['/projects', note.projectId]">
                        {{ note.projectCode }} - {{ note.projectName }}
                      </a>
                    </div>
                  </div>
                }

                @if (note.usersDisplay?.length > 0) {
                  <div class="tagged-users row mt-2 mb-3">
                    <div class="col">
                      <div class="d-flex align-items-center gap-2">
                        @for (item of getDisplayItems(note); track $index) {
                          <span class="badge bg-secondary grey4 px-2 py-1 nav-font12">{{ item }}</span>
                        }
                        @if (showPlusButton(note)) {
                          <span class="badge bg-secondary grey4 px-2 py-1 nav-font12 font-weight-bold nav-accent-blue"
                                container="body"
                                (mouseenter)="currentNoteTooltip = note"
                                placement="bottom"
                                [tooltip]="tooltipTemplate">
                            +{{ getRemainingCount(note) }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                }

                <div class="row mt-2">
                  <div class="col">
                    @if (!notesConfirmEdits[note.id]?.editModeOn) {
                       <div class="nav-font14 grey4 word-wrap-break">
                          <div class="note-message pr-2 mb-2" [innerHTML]="parseNote(note.message, note.id)" (click)="onNoteMessageClick($event, note)"></div>
                      </div>
                    }
                  </div>
                </div>
                <div class="d-flex align-items-center flex-wrap mt-2" [class.d-none]="notesConfirmEdits[note.id]?.editModeOn">
                  <div class="d-flex align-items-center">
                    <div class="reactions-group d-flex align-items-center">
                      @for (reaction of note.reactions; track reaction; let reactionIdx = $index) {
                        <button type="button" [tooltip]="reactionTooltip" placement="bottom" container="body" containerClass="reactionTooltip" class="likes cursor-pointer d-inline-block bg-transparent {{reaction.reactedByMe ? 'reactedByMe' : ''}}" [attr.aria-pressed]="!!reaction.reactedByMe" (click)="reactToNote(note, reaction.type);">
                          <ng-template #reactionTooltip>
                            <table class="w-100">
                              <tbody>
                                @if (reaction.reactedByMe) {
                                  <tr>
                                    <td class="text-left pr-3">You</td>
                                    <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                  </tr>
                                }
                                @for (user of reaction.reactedBy; track name; let nameIdx = $index) {
                                  @if (nameIdx < 5) {
                                    <tr>
                                      <td class="text-left pr-3">{{user.name}}</td>
                                      <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                    </tr>
                                  }
                                  @if (nameIdx == 5) {
                                    <tr>
                                      <td class="text-left pr-3">and {{reaction.reactedBy.length - 5}} more...</td>
                                      <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                                    </tr>
                                  }
                                }
                              <tbody>
                            </table>
                          </ng-template>
                          <div class="d-flex align-items-center justify-content-center w-100 h-100">
                            <app-emoji class="mb-1" [size]="'small'" [onHoverAction]="'background-change'" [name]="reaction.type"></app-emoji>
                            <span class="reaction-count">{{reaction.reactedBy.length + (reaction.reactedByMe ? 1 : 0)}}</span>
                          </div>
                        </button>
                      }
                      <ng-template *ngTemplateOutlet="reactions; context: { $implicit: note }"></ng-template>
                    </div>
                  </div>
                  @if (note.replies?.length > 0) {
                    <button type="button" class="d-flex align-items-center ml-auto cursor-pointer grey4 nav-font14 reply-toggle bg-transparent border-0 p-0" [attr.aria-expanded]="!!note.showReplies" (click)="note.showReplies = !note.showReplies">
                      <i class="far fa-comment-alt mr-1" aria-hidden="true"></i>
                      <span class="mr-1">{{ note.replies.length }} {{ note.replies.length === 1 ? 'reply' : 'replies' }}</span>
                      <i class="far nav-font10" [ngClass]="{'fa-chevron-up': note.showReplies, 'fa-chevron-down': !note.showReplies}" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              </div>
            </div>
            @if (note.showReplies && note.replies?.length > 0 && !notesConfirmEdits[note.id]?.editModeOn) {
              <div class="replies w-100 mt-4">
                <div class="items" *ngIf="note.showReplies">
                  <ng-template *ngTemplateOutlet="tplReplies; context: { $implicit: note }"></ng-template>
                </div>
              </div>
            }
            </div>
          </li>
        }
      </ul>
    }

  </div>
}

<ng-template #modalDelete>
  <div class="modal-header d-flex align-items-center justify-content-center">
    <div class="w-100">
      <div class="d-flex justify-content-end align-content-center">
        <button type="button" class="bg-transparent border-0 p-0" aria-label="Close" (click)="closeModal()"><i class="fas fa-close grey4" aria-hidden="true"></i></button>
      </div>
    </div>
  </div>
  <div class="modal-body pt-0 text-center">
    <h3 class="font-weight-bold grey5">Are you sure you want to delete this note?</h3>
    <h5 class="grey5 text-center d-block my-3">
      <button type="button" class="bg-transparent border-0 p-0" aria-label="Close" (click)="closeModal()"><i class="fak fa-info grey4" aria-hidden="true"></i></button>
      This action cannot be undone.
    </h5>
  </div>
  <div class="modal-footer">
    <div class="row d-flex w-100" >
      <div class="col text-right pr-0">
        <button type="button" class="btn btn-sm nav-btn-primary mx-1 shadow-none" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-sm nav-btn-accent shadow-none" (click)="delete()">Delete</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalNote>
  <div class="modal-header d-flex align-items-center justify-content-between">
    <h3 class="font-weight-bold nav-secondary nav-font16 mb-0">{{ noteModal?.title }}</h3>
    <button type="button" class="bg-transparent border-0 p-0" aria-label="Close" (click)="closeNoteModal()"><i class="fas fa-close grey4" aria-hidden="true"></i></button>
  </div>
  <div class="modal-body pt-2 pb-2 px-3">
    @if (noteModal?.readOnly) {
      <div class="note-modal-message note-message nav-font14 grey4 word-wrap-break" [innerHTML]="noteModal?.target?.message"></div>
      @if (!noteModal?.isReply && noteModal?.target?.attachments?.length > 0) {
        <div class="pt-2">
          <ng-template *ngTemplateOutlet="tplNoteAttachments; context: { $implicit: noteModal.target }"></ng-template>
        </div>
      }
    } @else {
      <div class="note-input-box">
        <div class="ckeditor note-modal-editor pl-3 pr-0 position-relative">
          <or-wysiwyg (messageEvent)="setModalEditorMessage($event)" [config]="modalEditorConfig" [data]="modalEditorData"></or-wysiwyg>
        </div>
      </div>
      @if (modalAttachmentDraftKey) {
        <div class="pt-2">
          <ng-template *ngTemplateOutlet="tplAttachmentEditor; context: { $implicit: modalAttachmentDraftKey, idScope: 'modal' }"></ng-template>
        </div>
      }
    }
  </div>
  <div class="modal-footer pt-0">
    <div class="row d-flex w-100">
      <div class="col text-right pr-0">
        @if (noteModal?.readOnly) {
          @if (noteModal?.canEdit) {
            <button type="button" class="btn btn-sm nav-btn-primary mx-1 shadow-none" (click)="editFromView()">Edit</button>
          }
          <button type="button" class="btn btn-sm nav-btn-accent shadow-none" (click)="closeNoteModal()">Close</button>
        } @else {
          <button type="button" class="btn btn-sm nav-btn-primary mx-1 shadow-none" (click)="cancelNoteModal()">Cancel</button>
          <button type="button" class="btn btn-sm nav-btn-accent shadow-none" (click)="saveNoteModal()">Save</button>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tplNoteTypes let-note>
  <div class="w-100" dropdown #dropdownNoteType="bs-dropdown" placement="bottom left" container="body">
    <button type="button" class="share-type-btn d-flex align-items-center cursor-pointer bg-transparent" dropdownToggle aria-label="Select note share type" aria-haspopup="menu" [attr.aria-expanded]="dropdownNoteType.isOpen" [class.isDisabled]="note?.id">
      <div class="type-icon-circle mr-2" [ngClass]="{'team-bg': note.userType === 'Team', 'client-bg': note.userType === 'Client', 'vendor-bg': note.userType === 'Vendor'}">
        @if (note.userType === 'Team') { <i class="fak fa-team-2" aria-hidden="true"></i> }
        @else if (note.userType === 'Client') { <i class="fak fa-suitcase" aria-hidden="true"></i> }
        @else if (note.userType === 'Vendor') { <i class="fas fa-cart-shopping nav-font12" aria-hidden="true"></i> }
      </div>
      <span class="nav-font14 nav-secondary font-weight-bold">{{ note.userType === 'Team' ? 'My Team' : note.userType }}</span>
      <i class="far grey4 ml-auto nav-font16" [class.fa-angle-up]="dropdownNoteType.isOpen" [class.fa-angle-down]="!dropdownNoteType.isOpen" aria-hidden="true"></i>
    </button>
    <div *dropdownMenu class="dropdown-menu share-type-dropdown py-1" role="menu">
      <li role="menuitem" tabindex="0" class="share-type-option d-flex align-items-center px-2 pb-2 pt-1 cursor-pointer border-bottom" (click)="changeType(note, 'Team')" (keydown.enter)="changeType(note, 'Team')" (keydown.space)="$event.preventDefault(); changeType(note, 'Team')">
        <div class="type-icon-circle team-bg mr-3">
          <i class="fak fa-team-2" aria-hidden="true"></i>
        </div>
        <div>
          <div class="nav-font14 font-weight-bold nav-secondary">My Team</div>
          <div class="nav-font12 grey4">Private to OpinionRoute staff</div>
        </div>
      </li>
      <li role="menuitem" tabindex="0" class="share-type-option d-flex align-items-center px-2 py-2 cursor-pointer border-bottom" (click)="changeType(note, 'Client')" (keydown.enter)="changeType(note, 'Client')" (keydown.space)="$event.preventDefault(); changeType(note, 'Client')">
        <div class="type-icon-circle client-bg mr-3">
          <i class="fak fa-suitcase" aria-hidden="true"></i>
        </div>
        <div>
          <div class="nav-font14 font-weight-bold nav-secondary">Client</div>
          <div class="nav-font12 grey4">Visible to client contacts</div>
        </div>
      </li>
      <li role="menuitem" tabindex="0" class="share-type-option d-flex align-items-center px-2 py-2 cursor-pointer" (click)="changeType(note, 'Vendor')" (keydown.enter)="changeType(note, 'Vendor')" (keydown.space)="$event.preventDefault(); changeType(note, 'Vendor')">
        <div class="type-icon-circle vendor-bg mr-3">
          <i class="fas fa-cart-shopping nav-font12" aria-hidden="true"></i>
        </div>
        <div>
          <div class="nav-font14 font-weight-bold nav-secondary">Vendor</div>
          <div class="nav-font12 grey4">Shared to vendor portal</div>
        </div>
      </li>
    </div>
  </div>
</ng-template>

<ng-template #tplReplies let-note>
  @for (reply of note.replies; track reply; let replyIdx = $index) {
    <div class="reply-item my-3" [class.reply-active]="notesConfirmEdits[reply.id]?.editModeOn">
      <div class="profile-image">
        <or-profile-image [name]="reply.name" [url]="reply.image" size="medium" showInitials="true"></or-profile-image>
      </div>
      <div class="mb-1">
        <div class="info-grid">
          <div class="d-flex align-items-center">
            <span class="d-block font-weight-bold nav-black2 nav-font14 mb-0 text-truncate note-author" [tooltip]="reply.name" container="body" placement="bottom">{{ reply.name }}</span>
            @if (!isVendorOrClient) {<span class="badge badge-pill nav-font12 ml-2 mr-1 font-weight-normal" [ngClass]="{'badge-note-team': note.userType === 'Team', 'badge-note-client': note.userType === 'Client', 'badge-note-vendor': note.userType === 'Vendor'}">{{ note.userType }}</span>}
            @if(note.partnerName?.length > 0){<span class="badge badge-pill badge-vendor-label nav-font11 font-weight-normal flex-shrink-0" container="body" [tooltip]="note.partnerName" placement="bottom">{{ note.partnerName.length > 6 ? (note.partnerName | slice:0:6) + '...' : note.partnerName }}</span>}
          </div>
          <div class="d-flex justify-content-end align-items-center note-actions-col">
            <span class="grey4 nav-font10 text-nowrap flex-shrink-0 mr-2" container="body" placement="bottom" [tooltip]="(reply.createdOn | date:'MMM d, y HH:mm')">{{ reply.createdOn | timeAgo: 'compact' }}</span>
            @if (reply.isEdited) {<span class="grey4 nav-font10 text-nowrap flex-shrink-0 mr-2">Edited</span>}
            <button type="button" class="expand-note-btn bg-transparent border-0 p-0 grey4 expand-note-reveal d-inline-flex align-items-center mr-2" aria-label="Expand" tooltip="Expand" container="body" placement="bottom" (click)="openReplyView(reply)">
              <i class="fas fa-arrows-maximize nav-font12" aria-hidden="true"></i>
            </button>
            <div class="text-right" dropdown #ddReply="bs-dropdown" container="body" placement="bottom right">
              @if (auth.getUser().id == reply.createdBy) {
                @if (!notesConfirmEdits[reply.id]?.editModeOn && !addNoteModeOn) {
                  <button type="button" class="fak fa-ellipsis-vertical fa-lg cursor-pointer nav-black2 bg-transparent border-0 p-0" dropdownToggle aria-label="Reply options" aria-haspopup="menu" [attr.aria-expanded]="ddReply.isOpen"></button>
                }
              }
              <ul class="note-actions dropdown-menu dropdown-menu-right position-relative grey4 cursor-pointer p-1 nav-font14" (mouseleave)="ddReply.hide()" *dropdownMenu role="menu" aria-labelledby="button-triggers-manual">
                <button type="button" class="dropdown-item px-3" role="menuitem" (click)="notesConfirmEdits[reply.id] = { editModeOn: true, message: reply.message }; ddReply.hide()">Edit</button>
                <hr class="mx-2 my-0">
                <button type="button" class="dropdown-item px-3" role="menuitem" (click)="deleteReply(reply); ddReply.hide()">Delete</button>
              </ul>
            </div>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col">
            @if (!notesConfirmEdits[reply.id]?.editModeOn) {
              <div class="nav-font14 grey4 word-wrap-break">
                <div class="note-message pr-2 mb-2" [innerHTML]="parseNote(reply.message, reply.id)" (click)="onReplyMessageClick($event, reply)"></div>
              </div>
            }
            @if (notesConfirmEdits[reply.id]?.editModeOn) {
              <div class="col ckeditor position-relative pl-0 pr-0">
                <or-wysiwyg (messageEvent)="notesConfirmEdits[reply.id].message = $event" [config]="editorReplyConfig" [data]="notesConfirmEdits[reply.id].message"></or-wysiwyg>
                <div class="save-note">
                  <button type="button" (click)="cancelReply(reply)" class="btn btn-sm nav-btn-primary mx-2 shadow-none font-weight-bold py-1">Cancel</button>
                  <button type="button" (click)="editReply(reply)" class="btn btn-sm nav-btn-accent shadow-none py-1">Submit</button>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Emoji -->
        <div class="mt-2" [class.invisible]="notesConfirmEdits[reply.id]?.editModeOn">
          <div class="reactions-group d-flex align-items-center">
            @for (reaction of reply.reactions; track reaction; let reactionIdx = $index) {
              <button type="button" [tooltip]="reactionTooltip" placement="bottom" container="body" containerClass="reactionTooltip" class="likes cursor-pointer d-inline-block bg-transparent {{reaction.reactedByMe ? 'reactedByMe' : ''}}" [attr.aria-pressed]="!!reaction.reactedByMe" (click)="reactToNote(reply, reaction.type);">
                <ng-template #reactionTooltip>
                  <table class="w-100">
                    <tbody>
                      @if (reaction.reactedByMe) {
                        <tr>
                          <td class="text-left pr-3">You</td>
                          <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                        </tr>
                      }
                      @for (user of reaction.reactedBy; track name; let nameIdx = $index) {
                        @if (nameIdx < 5) {
                          <tr>
                            <td class="text-left pr-3">{{user.name}}</td>
                            <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                          </tr>
                        }
                        @if (nameIdx == 5) {
                          <tr>
                            <td class="text-left pr-3">and {{reaction.reactedBy.length - 5}} more...</td>
                            <td class="text-right"><app-emoji class="mb-1" [size]="'small'" [name]="reaction.type"></app-emoji></td>
                          </tr>
                        }
                      }
                    <tbody>
                  </table>
                </ng-template>
                <div class="d-flex align-items-center justify-content-center w-100 h-100">
                  <app-emoji class="mb-1" [size]="'small'" [onHoverAction]="'background-change'" [name]="reaction.type"></app-emoji>
                  <span class="reaction-count">{{reaction.reactedBy.length + (reaction.reactedByMe ? 1 : 0)}}</span>
                </div>
              </button>
            }
            <ng-template *ngTemplateOutlet="reactions; context: { $implicit: reply }"></ng-template>
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #reactions let-note>
  <span class="emojis position-relative cursor-pointer d-inline-block" container="body" dropdown dropdownToggle>
    <div class="d-flex align-items-center justify-content-end w-100 h-100">
      <i class="fal fa-smile-plus grey5 cursor-pointer nav-font14"></i>
    </div>
    <div *dropdownMenu class="reactions-dropdown dropdown-menu py-0 nav-font14 m-0" role="menu" aria-labelledby="button-basic" >
      <div class="menu-container overflow-y">
        <ul class="d-flex py-0 px-2 my-0 noShadow">
          @for (reactionType of reactionTypes; track $index) {
            <li role="menuitem">
              <div class="dropdown-list-item cursor-pointer font-weight-normal w-100">
                <app-emoji (click)="reactToNote(note, reactionType);" class="" [size]="'medium'" [onHoverAction]="'enlarge'"  [name]="reactionType"></app-emoji>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </span>
</ng-template>

<!-- Saved attachments on a note: files download, links open in a new tab -->
<ng-template #tplNoteAttachments let-note>
  <div class="note-attachments mb-2">
    @for (attachment of note.attachments; track attachment.id) {
      <div class="d-flex align-items-center nav-font12 mb-1">
        @if (attachment.assetType === 'file') {
          <button type="button" class="note-attachment-name bg-transparent border-0 p-0 nav-accent-blue text-left text-truncate" [attr.aria-label]="'Download ' + attachment.fileName" (click)="downloadAttachment(note.id, attachment)">
            <i class="far fa-paperclip grey4 mr-1" aria-hidden="true"></i>{{ attachment.fileName }}
          </button>
        } @else {
          <a class="note-attachment-name nav-accent-blue text-truncate" [href]="attachment.url" target="_blank" rel="noopener noreferrer">
            <i class="far fa-link grey4 mr-1" aria-hidden="true"></i>{{ attachment.fileName }}
          </a>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Attach files / links to a note while composing or editing it. Saved attachments
     (edit only) and the ones added in this session are listed and can be removed. -->
<ng-template #tplAttachmentEditor let-draftKey let-idScope="idScope">
  <div class="attachment-editor">
    @for (attachment of keptAttachmentsFor(draftKey); track attachment.id) {
      <div class="d-flex align-items-center nav-font12 mb-1">
        <i class="far grey4 mr-1" [class.fa-paperclip]="attachment.assetType === 'file'" [class.fa-link]="attachment.assetType === 'link'" aria-hidden="true"></i>
        <span class="note-attachment-name text-truncate grey5">{{ attachment.fileName }}</span>
        <button type="button" class="bg-transparent border-0 p-0 ml-2 grey4" [attr.aria-label]="'Remove ' + attachment.fileName" (click)="removeKeptAttachment(draftKey, attachment.id)">
          <i class="fas fa-close" aria-hidden="true"></i>
        </button>
      </div>
    }
    @for (attachment of attachmentsFor(draftKey); track $index) {
      <div class="d-flex align-items-center nav-font12 mb-1">
        <i class="far grey4 mr-1" [class.fa-paperclip]="attachment.assetType === 'file'" [class.fa-link]="attachment.assetType === 'link'" aria-hidden="true"></i>
        <span class="note-attachment-name text-truncate grey5">{{ attachment.fileName }}</span>
        <button type="button" class="bg-transparent border-0 p-0 ml-2 grey4" [attr.aria-label]="'Remove ' + attachment.fileName" (click)="removeDraftAttachment(draftKey, $index)">
          <i class="fas fa-close" aria-hidden="true"></i>
        </button>
      </div>
    }
    @for (upload of uploadsFor(draftKey); track upload.id) {
      <div class="nav-font12 mb-2">
        <div class="d-flex align-items-center">
          <i class="far fa-paperclip grey4 mr-1" aria-hidden="true"></i>
          <span class="note-attachment-name text-truncate grey4">{{ upload.fileName }}</span>
          <span class="grey4 ml-2">{{ upload.progress }}%</span>
        </div>
        <div class="progress mt-1">
          <div class="progress-bar bg-success" role="progressbar" [style.width]="upload.progress + '%'" [attr.aria-valuenow]="upload.progress" aria-valuemin="0" aria-valuemax="100" [attr.aria-label]="'Uploading ' + upload.fileName"></div>
        </div>
      </div>
    }
    @if (linkDrafts[draftKey]) {
      <div class="attachment-link-form mb-2">
        <label class="nav-font12 grey4 mb-1" [for]="'attachment-link-url-' + draftKey + (idScope ?? '')">Link</label>
        <input type="url" class="form-control form-control-sm nav-font12 mb-2" [id]="'attachment-link-url-' + draftKey + (idScope ?? '')" placeholder="https://" [(ngModel)]="linkDrafts[draftKey].url" (keydown.enter)="$event.preventDefault(); addLinkAttachment(draftKey)">
        <label class="nav-font12 grey4 mb-1" [for]="'attachment-link-name-' + draftKey + (idScope ?? '')">Link name (optional)</label>
        <input type="text" class="form-control form-control-sm nav-font12 mb-2" [id]="'attachment-link-name-' + draftKey + (idScope ?? '')" [(ngModel)]="linkDrafts[draftKey].name" (keydown.enter)="$event.preventDefault(); addLinkAttachment(draftKey)">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-sm nav-btn-primary shadow-none mr-2 py-1" (click)="closeLinkForm(draftKey)">Cancel</button>
          <button type="button" class="btn btn-sm nav-btn-accent shadow-none py-1" (click)="addLinkAttachment(draftKey)">Add Link</button>
        </div>
      </div>
    }
    <div class="d-flex align-items-center nav-font12">
      <input #attachmentFileInput type="file" class="d-none" (change)="onAttachmentFileSelected(draftKey, $event)">
      <button type="button" class="bg-transparent border-0 p-0 nav-accent-blue font-weight-bold mr-3" (click)="attachmentFileInput.click()">
        <i class="far fa-paperclip mr-1" aria-hidden="true"></i>Attach file
      </button>
      @if (!linkDrafts[draftKey]) {
        <button type="button" class="bg-transparent border-0 p-0 nav-accent-blue font-weight-bold mr-3" (click)="openLinkForm(draftKey)">
          <i class="far fa-link mr-1" aria-hidden="true"></i>Add link
        </button>
      }
      <span class="grey4 ml-auto">Max 500 MB per file</span>
    </div>
  </div>
</ng-template>

<ng-template #tooltipTemplate>
  <div class="d-flex flex-column">
    <span class="d-block" *ngFor="let user of currentNoteTooltip?.usersDisplay?.slice(1)">{{user}}</span>
  </div>
</ng-template>


